import * as moment from 'moment';

export class Penalty {
    id: number;
    date: moment.Moment;
    goal: boolean;
    adversaryTeamId: number;
    adversaryTeamName: string;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/penalty.model.ts